// The languages the submission flow is fully translated into.
//
// The language rule: a page is in one language, never half and half. The flow
// picks it from the account signed in in this tab (its saved preference), else
// ?lang=, else the browser (App.tsx, applySignedInLanguage below), and these
// pages accept it only if it is listed here. Anything else (Norwegian today) gets the flow in
// English rather than a page where the old signup's strings are translated and
// the new ones fall back to English.
//
// flowLanguage.test.ts fails if a language listed here is missing any string
// the flow uses, so adding a language means translating all of it first.

import i18next from "i18next";
import { setBrowserLang } from "helpers";
import { getSubmissionLanguage } from "../../../helpers/submissionAuth";

// English variants need no list of their own: the strings ARE English.
export const FLOW_LANGUAGES = ["en", "en_uk", "es", "fr"];

export const isSubmissionPath = (pathname: string): boolean =>
  pathname === "/submission" || pathname.startsWith("/submission/");

// The saved language of the actor signed in in this tab through the classic login. Never the
// shared stored user (cwb-react's CWB_USER): on this site that can be an earlier visitor's, or an
// agent's (decided 2026-10-30). Returns true when it switched.
export const applySignedInLanguage = (): boolean => {
  const language = getSubmissionLanguage();
  if (!language || language === i18next.language) return false;
  setBrowserLang(language);
  return true;
};

// Switches to English if the current language isn't complete for the flow.
// Returns true when it switched, so a page already on screen can re-render.
export const ensureFlowLanguage = (): boolean => {
  const current = i18next.language;
  if (!current || FLOW_LANGUAGES.includes(current)) return false;
  setBrowserLang("en"); // i18next and moment together, like every other switch
  return true;
};
